import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchQuestions,
  getQuestionError,
  getQuestions,
  getQuestionStatus,
} from "../../../redux/slice/questionSlice";
import Loading from "../../common/Loading";
import AlertBox from "../../common/AlertBox";
import QuestionList from "./QuestionList";
import { FaFilter, FaPlus, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchTopics, getTopics } from "../../../redux/slice/topicSlice";
import FilterQuestion from "./FilterQuestion";
import UpperSection from "../common/UpperSection";

const AdminQuestion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const questions = useSelector(getQuestions);
  const status = useSelector(getQuestionStatus);
  const error = useSelector(getQuestionError);

  const topics = useSelector(getTopics);

  const [topic, setTopic] = useState("");
  const [subject, setSubject] = useState("");
  const [marks, setMarks] = useState("");
  const [level, setLevel] = useState("");

  useEffect(() => {
    if (!questions) {
      dispatch(fetchQuestions());
      dispatch(fetchTopics());
    }
  }, [dispatch, questions]);

  const handleAdd = () => {
    navigate("/admin/add-question");
  };

  const filteredBySearch = questions?.filter((ques) => {
    return ques?.questions?.toLowerCase().includes(searchQuery);
  });

  const filteredQuestions = filteredBySearch?.filter((ques) => {
    if (topic) {
      if (subject) {
        return ques?.subjectId === subject;
      } else {
        return ques?.topicId === topic;
      }
    } else {
      return ques;
    }
  });

  const filteredByMarks = filteredQuestions?.filter((ques) => {
    if (marks) {
      return ques?.marks === marks;
    } else {
      return ques;
    }
  });

  const filteredByLevel = filteredByMarks?.filter((ques) => {
    if (level) {
      return ques?.level.toLowerCase() === level.toLowerCase();
    } else {
      return ques;
    }
  });

  const clearFilter = () => {
    setLevel("");
    setMarks("");
    setTopic("");
    setSubject("");
  };

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type={status} message={error} /> : null}

      {/* Upper Section */}
      <UpperSection
        title="Questions"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      {/* Lower Section */}
      <article className="bg-primary flex flex-col gap-6 w-full sm:p-7 p-2 rounded-[4px] border border-adminMainBorder">
        {/* Header Section */}
        <div className="flex sm:flex-row flex-col w-full justify-between sm:items-center">
          <span className="text-textPrimary text-[18px] font-semibold">
            Question List
          </span>
          <div className="flex sm:flex-row flex-col-reverse justify-between items-center gap-6">
            <div className="flex flex-row items-center gap-4"></div>
            <div>
              <div>
                {/* <FaSearch className="absolute m-3" />
                <input
                  type="search"
                  id="search"
                  name="Search"
                  placeholder="Search for question"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                  className="h-[40px] sm:w-[250px] focus:w-[450px] focus:ease-out transition-all duration-300 w-full pl-[40px] pr-[20px] rounded-[10px] border border-gray-500 focus:outline-none"
                /> */}
                <button
                  type="button"
                  onClick={handleAdd}
                  className="border-adminRightTextPrimary border sm:w-[180px] w-[50px] sm:h-[32px] h-[28px] rounded-[4px] text-adminRightTextPrimary flex gap-3 justify-center items-center"
                >
                  <FaPlus />
                  <span className="sm:block hidden">Add Question</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Filter box */}
        <div className="flex flex-col gap-6">
          <div className="flex flex-row gap-4">
            <span className="flex flex-row gap-2 items-center cursor-pointer text-textSecondary/40">
              <FaFilter />
              <span className="text-textSecondary">Filter</span>
            </span>

            <FilterQuestion
              topics={topics}
              setTopic={setTopic}
              topic={topic}
              setSubject={setSubject}
              subject={subject}
              setMarks={setMarks}
              marks={marks}
              setLevel={setLevel}
              level={level}
            />
            {topic || level || marks ? (
              <button
                onClick={clearFilter}
                type="button"
                className="flex flex-row gap-2 items-center px-2 h-[32px] rounded-[4px] bg-gray-500 text-white text-[12px] italic"
              >
                <span>Clear</span>
                <FaTimes className="" />
              </button>
            ) : null}
          </div>

          {/* Question list section */}
          {status === "success" ? (
            <QuestionList questions={filteredByLevel} />
          ) : null}
        </div>
      </article>
    </section>
  );
};

export default AdminQuestion;
